// Strict make->logo resolution for stored cars. The validator (#814) keeps
// cars.make canonical at write time, so unmatched legacy rows fall through
// to the monogram chip rather than a fuzzy first-word guess.
import { buildLogoAssets, buildLogoUrl, carLogoMonogram, type CarLogoAssets } from "@workspace/car-logos";
import { logoSlugForMake } from "@workspace/listing-requirements";

export type { CarLogoAssets };
export { carLogoMonogram };

function logoBasePath(): string {
  const env = (typeof import.meta !== "undefined" && (import.meta as { env?: { BASE_URL?: string } }).env) || {};
  const base = (env.BASE_URL || "/").replace(/\/$/, "");
  return `${base}/images/car-logos`;
}

export function resolveCarLogoUrl(make: string | null | undefined): string | null {
  const slug = logoSlugForMake(make);
  if (!slug) return null;
  return buildLogoUrl(slug, logoBasePath());
}

export function resolveCarLogoAssets(make: string | null | undefined): CarLogoAssets | null {
  const slug = logoSlugForMake(make);
  if (!slug) return null;
  return buildLogoAssets(slug, logoBasePath());
}
